"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiDeleteCoursePad = exports.apiJoinOrCreateCoursePad = exports.apiGetCoursePads = void 0;
const client_1 = require("./client");
const apiGetCoursePads = async (courseId, after) => {
    if (courseId) {
        const { data } = await client_1.default.get(`/course-pad/get-all/${courseId}`, {
            params: Object.assign({}, (after && { after: after.getTime() })),
        });
        return data;
    }
    const { data } = await client_1.default.get('/course-pad/get-all', {
        params: Object.assign({}, (after && { after: after.getTime() })),
    });
    return data;
};
exports.apiGetCoursePads = apiGetCoursePads;
const apiJoinOrCreateCoursePad = async (exerciseId, name, initialText, courseId) => {
    if (courseId) {
        const { data } = await client_1.default.post(`/course-pad/join-or-create/${courseId}`, {
            params: {
                exerciseId,
                name,
                initialText,
            },
        });
        return data;
    }
    const { data } = await client_1.default.post('/course-pad/join-or-create', {
        params: {
            exerciseId,
            name,
            initialText,
        },
    });
    return data;
};
exports.apiJoinOrCreateCoursePad = apiJoinOrCreateCoursePad;
const apiDeleteCoursePad = async (courseId, id) => {
    const { data } = await client_1.default.delete(`/course-pad/delete/${courseId}/${id}`);
    return data;
};
exports.apiDeleteCoursePad = apiDeleteCoursePad;
//# sourceMappingURL=coursePad.js.map